<template>
  <div>
      <!--订单详情-->
        <div class="product-detail"
             v-for="(merchandise, index) in merchandises">
          <img :src="getPayOrderMerchandiseLabelPath(merchandise)"
               class="product-label">
          <div class="block-item" style="padding-top: 10px;">
            <div class="block-address">
              <img v-if="merchandise.merchandiseDetailForClient && merchandise.merchandiseDetailForClient.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+merchandise.merchandiseDetailForClient.merchandiseIcon />
              <div class="item-detail">
                <span class="deep-text-color" style="font-size: 12px;" v-if="merchandise._titleList && merchandise._titleList.length > 0" >
                   <span v-for="title in merchandise._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font" v-if="merchandise._subTitleList && merchandise._subTitleList.length > 0" >
                  <span v-for="(subTitle, index) in merchandise._subTitleList">
                    <span v-if="index !== 0">/</span>
                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font" v-if="merchandise._abstractList && merchandise._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in merchandise._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
              </div>
            </div>
            <span class="light-text-color">X {{merchandise.quantity}}</span>
          </div>
          <div class="price-info">
            <span class="alert-text tiny-font bold-text" v-if="getMerchandiseDiscount(merchandise) < 1">{{getMerchandiseCategory(merchandise)}}{{getMerchandiseDiscount(merchandise)}}折</span>
            <span style="text-decoration: line-through;" class="light-text-color tiny-font" v-if="getMerchandiseInitPrice(merchandise) > merchandise.price">¥{{emkt.formatPrice(getMerchandiseInitPrice(merchandise))}}</span>
            <span class="research-font-color bold-text">¥{{emkt.formatPrice(merchandise.price)}}</span>
          </div>
          <div class="split-line"></div>
        </div>
        <div class="block-item" style="height: 30px;">
          <span class="light-text-color">折后价小记</span>
          <div style="display: flex; justify-content: flex-end;">
            <span style="text-decoration: line-through;" class="light-text-color tiny-font" v-if="catalogueTotalPrice > goodsPrice">¥{{emkt.formatPrice(catalogueTotalPrice)}}</span>
            <span class="research-font-color bold-text">¥{{emkt.formatPrice(goodsPrice)}}</span>
          </div>
        </div>
        <div class="block-item" style="height: 30px;">
          <div>
            <span class="light-text-color">运费</span>
            <i class="icon-font emkt-icon-gantanhao light-text-color" style="font-size:13px;" @click="showExpressMessage"></i>
          </div>
          <span class="research-font-color bold-text">¥{{emkt.formatPrice(expressFee)}}</span>
        </div>
        <div class="block-item" style="height: 30px;"  v-if="showCashCoupon">
          <span class="light-text-color">现金券</span>
          <span class="bold-text alert-text">- ¥{{emkt.formatPrice(cashCoupon.value)}}</span>
        </div>
        <div class="full-split-line"></div>
        <div class="block-item" style="height: 40px;">
          <span class="light-text-color">共{{totalCount}}件商品</span>
          <div>
            <span class="light-text-color">总计</span>
            <span class="research-font-color bold-text" style="font-size: 16px;">¥{{emkt.formatPrice(totalPrice)}}</span>
          </div>
        </div>

  </div>
</template>

<script>
  import EMKT from '@/emkt.js'

  export default {
    props: ['order'],
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/'
      }
    },
    computed: {
      expressFee () {
        return this.order && this.order.expressPrice
      },
      totalPrice () {
        return this.order && this.order.totalPrice
      },
      goodsPrice () {
        return this.order && this.order.price
      },
      showCashCoupon () {
        return this.cashCoupon && ![EMKT.COUPON_TYPE_SPECIAL_FUND, EMKT.COUPON_TYPE_NEW_DISCOUNT].includes(this.cashCoupon.type)
      },
      cashCoupon () {
        return this.order && this.order.coupons && this.order.coupons[0]
      },
      merchandises () {
        let merchandiseList = []
        if (this.order.merchandises.length === 0) {
          for (let i in this.order.subOrders) {
            for (let j in this.order.subOrders[i].merchandises) {
              merchandiseList.push(this.order.subOrders[i].merchandises[j])
            }
          }
        } else {
          merchandiseList = this.order.merchandises
        }
        for (let j = 0; j < merchandiseList.length; j++) {
          if (!merchandiseList[j]._titleList) {
            let _subTitleList = []
            let _abstractList = []
            let _titleList = []
            merchandiseList[j].attributes.forEach(par => {
              if (par.key.indexOf('GeneInfo') !== -1 && par.displayable === 1 && par.value) {
                _subTitleList.push({
                  valueText: par.valueLabel
                })
              }
              if (par.key === 'TVInfo' && par.value) {
                _abstractList.push({
                  valueText: par.valueLabel
                })
              }
            })
            merchandiseList[j]._subTitleList = _subTitleList
            merchandiseList[j]._abstractList = _abstractList
            let name = {}
            name.valueText = merchandiseList[j].merchandiseLabel || merchandiseList[j].productName
            _titleList.push(name)
            merchandiseList[j]._titleList = _titleList
          }
        }
        return merchandiseList.filter(mer => mer.presentQuantity === 0)
      },
      catalogueTotalPrice () {
        if (!this.merchandises || this.merchandises.length === 0) return 0
        return this.merchandises.reduce((pre, current) => {
          if (current.presentQuantity === 0) {
            return pre + this.getMerchandiseInitPrice(current)
          } else {
            return pre
          }
        }, 0)
      },
      totalCount () {
        if (!this.merchandises || this.merchandises.length === 0) return 0
        let count = 0
        this.merchandises.forEach(merchandise => {
          count += (merchandise.presentQuantity === 0 ? merchandise.quantity : 0)
        })
        return count
      }
    },
    mounted () {
      this.$weui.loading().hide()
    },
    methods: {
      goToDetail (product) {
        this.$router.push({name: 'FinderOrderDeail', params: {merchandises: product, id: 1, order: this.order}, query: {id: 1}})
        // let id = product.categoryId
        // let cId
        // if (product.merchandiseDetailForClient) {
        //   cId = product.merchandiseDetailForClient.categoryId
        // }
        // if (id !== 10 && cId !== 10) {
        //   if (id === 20 || cId === 20) {
        //     this.$router.push({name: 'FinderOrderDeail', params: {merchandises: product, id: 1, order: this.order}, query: {id: 1}})
        //   } else {
        //     this.$router.push({name: 'finderMerchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId, showFooter: '0' }, params: {order: this.order}})
        //   }
        // }
      },
      getMerchandiseCategory (merchandise) {
        let categoryLabel = ''
        switch (merchandise.categoryId) {
          case 20:
            categoryLabel = '定制'
            break
          case 12:
            categoryLabel = '细胞类'
            break
          default:
            categoryLabel = '现货'
        }
        return categoryLabel
      },
      getMerchandiseDiscount (merchandise) {
        const discount = merchandise.priceMin / merchandise.cataloguePrice
        return discount < 1 ? (discount * 10).toFixed(1) : 1
      },
      getMerchandiseInitPrice (merchandise) {
        return merchandise.categoryId === 20 ? merchandise.priceMax : merchandise.initPrice
      },
      showExpressMessage () {
        this.$weui.dialog({
          title: '运费说明',
          content: '为确保您所购产品的稳定性和活性，我们将选择最合适的物料（干冰或冰袋）进行产品包装，并用顺丰物流进行发货，以保障物流高效安全。如您的订单含有多个不同周期的产品，且周期相差超过10个工作日，产品将分批进行发货，并根据批次收取相应的运费。',
          buttons: [
            {
              label: '我知道了'
            }
          ]
        })
      },
      // 获取下单时商品类型显示标签
      getPayOrderMerchandiseLabelPath (merchandise) {
        const route = '/static/img/'
        if (merchandise.categoryId === 20 || merchandise.categoryId === 10) {
          return merchandise.amplification === 1 ? route + '扩增标签.png' : route + '定制标签.png'
        } else {
          return route + '现货标签.png'
        }
      }
    }
  }
</script>

<style scoped>
  .product-detail {
    position: relative;
  }
  .product-label {
    z-index: 5;
    width: 30px;
    position: absolute;
    top: 0;
    left: -15px;
  }
  .text-overflow-hidden {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .largeIcon {
    position: relative;
    margin-right: 1.33vw;
    width: 13.87vw;
    height: 13.87vw;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    background-color: #fff;
  }

  .block-item {
    /*height: 62px;*/
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 75%;
  }

  .price-info {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .full-split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    margin-left: -15px;
    height: 1px;
  }

</style>



// WEBPACK FOOTER //
// OrderMerchandises.vue?1dcb61c1